var _defs, _defs2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "map-background",
    x: 0,
    y: 0,
    width: 10,
    height: 10,
    patternUnits: "userSpaceOnUse",
    patternContentUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "pattern-circle",
    cx: 5,
    cy: 5,
    r: 4
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "map-background-hovered",
    x: 0,
    y: 0,
    width: 10,
    height: 10,
    patternUnits: "userSpaceOnUse",
    patternContentUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "pattern-circle-hovered",
    cx: 5,
    cy: 5,
    r: 4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapBackground);
export default __webpack_public_path__ + "static/media/map-background.55602a18.svg";
export { ForwardRef as ReactComponent };